import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { Carousel } from "react-responsive-carousel";
import "react-responsive-carousel/lib/styles/carousel.min.css";
import { FaStar } from "react-icons/fa";

// Imported images and their names for brands and collections
import im6 from "../assets/images/im6.png";
import im7 from "../assets/images/im7.png";
import im8 from "../assets/images/im8.png";
import im9 from "../assets/images/im9.jpeg";
import im10 from "../assets/images/im10.jpeg";
import im11 from "../assets/images/im11.png";
import im12 from "../assets/images/im12.png";
import im13 from "../assets/images/im13.png";
import im14 from "../assets/images/im14.jpg";
import im15 from "../assets/images/im15.png";
import im16 from "../assets/images/im16.png";
import im17 from "../assets/images/im17.png";
import im33 from "../assets/images/im33.jpg";

// Imported images and their names for products
import DesignerMetal from "../assets/images/DesignerMetal.png";
import FrameLess from "../assets/images/FrameLess.png";
import FullFrame from "../assets/images/FullFrame.png";
import HalfFrame from "../assets/images/HalfFrame.png";
import SafetyGlassess from "../assets/images/SafetyGlasses.png";
import Sunglassess from "../assets/images/SunGlasses.png";

const brand = [im6, im7, im8, im9, im10, im11, im12, im13, im14, im15, im16, im17];
const brands = [
  "Zeiss",
  "Essilor",
  "Rodenstock",
  "Vision Rx",
  "Nova",
  "Kodak",
  "Vogue",
  "Tom Ford",
  "Ray-Ban",
  "Carrera",
  "Police",
  "Boss",
  "Mont Blanc"
];
const collections = [
  "DesignerMetal&MetalFrame",
  "FrameLess",
  "FullFrame",
  "HalfFrame",
  "LDB",
  "SafetyGlassess",
  "Sunglassess",
  "Types"
];
const images = [im9, im10, im33];

// Simple star rating component (assumes rating out of 5)
function StarRating({ rating = 4 }) {
  const stars = [];
  for (let i = 0; i < 5; i++) {
    stars.push(
      <FaStar
        key={i}
        className={i < rating ? "text-black" : "text-gray-300"}
        size={24}
      />
    );
  }
  return <div className="flex space-x-1">{stars}</div>;
}

export default function ProductShowcase() {
  const [user, setUser] = useState(null);
  const navigate = useNavigate();

  // Load user info from localStorage (if available)
  useEffect(() => {
    const savedUser = localStorage.getItem("user");
    if (savedUser) {
      setUser(JSON.parse(savedUser));
    }
  }, []);

  // Array of products using imported images and their labels
  const importedProducts = [
    { image: DesignerMetal, name: "Designer Metal" },
    { image: FrameLess, name: "Frame Less" },
    { image: FullFrame, name: "Full Frame" },
    { image: HalfFrame, name: "Half Frame" },
    { image: SafetyGlassess, name: "Safety Glasses" },
    { image: Sunglassess, name: "Sunglasses" },
  ];

  // Mapping from product name to its corresponding route
  const routeMapping = {
    "Designer Metal": "/dma",
    "Frame Less": "/fla",
    "Full Frame": "/ffa",
    "Half Frame": "/hfa",
    "Sunglasses": "/sga",
    "Safety Glasses": "/sa",
  };

  const handleImageClick = (product) => {
    const targetRoute = routeMapping[product.name];
    if (targetRoute) {
      navigate(targetRoute);
    }
  };

  return (
    <div className="container mx-auto p-4 sm:p-6">
      <div className="flex flex-col md:flex-row">
        {/* Left Side: User Greeting and Ratings */}
        <div className="md:w-2/5 p-4 flex flex-col items-start border-b md:border-b-0">
          <h1 className="text-4xl sm:text-5xl md:text-6xl Rubik-Bold mb-2">
            Hello{" "}
            <span className="bg-gradient-to-r from-blue-400 to-pink-400 bg-clip-text text-transparent text-5xl sm:text-6xl md:text-7xl Rubik-Medium">
              {user ? user.username : "Guest"}
            </span>
          </h1>
          <h2 className="text-xl sm:text-2xl md:text-3xl text-gray-400 Rubik-Medium mb-2">
            Know about our services
          </h2>
          <h3 className="text-2xl sm:text-3xl md:text-4xl Rubik-Medium mb-3 md:mb-4">Ratings</h3>
          <StarRating rating={4} />
          <p className="mt-2 text-lg sm:text-xl md:text-2xl Rubik-Light">4 out of 5</p>
          <p>
            <a
              href="https://g.co/kgs/b28pNt1"
              target="_blank"
              rel="noopener noreferrer"
              className="bg-gradient-to-r from-blue-400 to-pink-400 bg-clip-text text-transparent text-lg sm:text-xl md:text-2xl Rubik-Light hover:underline"
            >
              https://g.co/kgs/b28pNt1
            </a>
          </p>
        </div>
        {/* Right Side: Carousel */}
        <div className="md:w-3/5 p-4">
          {importedProducts.length > 0 ? (
            <Carousel
              showThumbs={false}
              infiniteLoop
              autoPlay
              interval={3000}
              showStatus={false}
              showIndicators={false}
              emulateTouch
              className="rounded-md"
            >
              {importedProducts.map((product, index) => (
                <div
                  key={index}
                  onClick={() => handleImageClick(product)}
                  className="border border-gray-300 rounded-xl cursor-pointer"
                >
                  <img
                    src={product.image}
                    alt={product.name}
                    className="mx-auto object-cover h-64 sm:h-80 md:h-96 w-full sm:w-80 md:w-96 rounded-xl"
                  />
                  <div className="mt-2 bg-black py-2 rounded-md">
                    <p className="text-center text-white text-base sm:text-lg Rubik-Bold">
                      {product.name}
                    </p>
                  </div>
                </div>
              ))}
            </Carousel>
          ) : (
            <p className="text-center text-base sm:text-lg">Loading products...</p>
          )}
        </div>
      </div>
    </div>
  );
}